<div class="switch-view-container">
  <ng-container *ngIf="representatives.length; else noRepresentatives">
    <table class="uk-table uk-table-divider uk-table-striped uk-table-hover uk-table-small uk-table-middle">
      <thead>
        <tr>
          <th class="uk-text-nowrap" i18n="@@name">name</th>

          <th class="uk-text-nowrap" i18n="@@email">email</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let representative of representatives">
          <td>
            <a [routerLink]="['/users', representative.id]">
              <ng-container *ngIf="representative.first_name && representative.last_name; else noName">
                {{ representative.first_name + ' ' + representative.last_name | titlecase | namesWithDash }}
              </ng-container>
              <ng-template #noName>
                <fa-icon icon="user"></fa-icon>
              </ng-template>
            </a>
          </td>

          <td>
            <a href="mailto:{{ representative.email }}">{{ representative.email }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <ng-template #noRepresentatives>
    <div class="uk-text-center" i18n="@@noRepresentatives">No representatives has been registered so far.</div>
  </ng-template>
</div>
